/* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/

import * as actions from '../payout-action/payout.action';
import { SalesPayoutState, SalesPayoutStateRecord } from './payout.state';

export const initialState: SalesPayoutState = new SalesPayoutStateRecord() as unknown as SalesPayoutState;

export function reducer(
  state = initialState, { 
    type, payload 
  }: any
): SalesPayoutState {
  if (!type) {
    return state;
  }

  switch (type) {

    // <------------------ PAYOUT LIST--------------------> //

    case actions.ActionTypes.GET_PAYOUT_LIST_ACTION: {
      return Object.assign({}, state, {
        payoutList: [],
        payoutLoading: true,
        payoutListLoaded: false,
        payoutListFailed: false,
      });
    }

    case actions.ActionTypes.GET_PAYOUT_LIST_SUCCESS: {
      return Object.assign({}, state, {
        payoutList: payload,
        payoutListLoading: false,
        payoutListLoaded: true,
        payoutListFailed: false,
      });
    }

    case actions.ActionTypes.GET_PAYOUT_LIST_FAIL: {
      return Object.assign({}, state, {
        payoutList: [],
        payoutListLoading: false,
        payoutListLoaded: false,
        payoutListFailed: true,
      });
    }

    default: {
      return state;
    }
  }
}

export const payoutList = (state: SalesPayoutState) => state.payoutList;
export const payoutListLoading = (state: SalesPayoutState) => state.payoutListLoading;
export const payoutListLoaded = (state: SalesPayoutState) => state.payoutListLoaded;
export const payoutListFailed = (state: SalesPayoutState) => state.payoutListFailed;